// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2282":"css/admin-app.6759","6087":"css/app.6759"}[chunkId] + ".css";
};